// base
import React from 'react';

// styles
import { StyledPageLoader } from './style';

// libraries
import { Spin } from 'antd';

export const PageLoader = () => {
  return (
    <StyledPageLoader>
      <Spin size="large" />
    </StyledPageLoader>
  );
};
